import { z } from 'zod'

export const marketMakerUpdateTelegramChatBodySchema = z.object({
  telegramChatId: z.string().nullable().optional(),
  isTelegramBotGoogleDriveNotificationsEnabled: z.boolean().optional(),
  isTelegramBotWeeklyDispatchGapAlertsEnabled: z.boolean().optional(),
})
